(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["occhio-card-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('occhio-card-media')) {
  const pending = new Set();
  let active = 0;
  let warmReady = false;
  const drain = () => {
    if (!warmReady) return;
    while (active < 3 && pending.size) {
      const card = pending.values().next().value;
      pending.delete(card);
      if (!card.isConnected || !card.nearby) continue;
      active++;
      card.loadSecondary('low').finally(() => { active--; drain(); });
    }
  };
  const warm = () => {
    const start = () => { warmReady = true; drain(); };
    if ('requestIdleCallback' in window) requestIdleCallback(start, {timeout:1000});
    else setTimeout(start, 0);
  };
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm, {once:true});
  const connection = navigator.connection;
  const warmOnSight = window.matchMedia('(any-hover: hover) and (any-pointer: fine)').matches
    && !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '');
  const observer = warmOnSight && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      entry.target.nearby = entry.isIntersecting;
      if (entry.isIntersecting) entry.target.prepareSecondary();
      else pending.delete(entry.target);
    }
  }, {rootMargin: '400px 0px'}) : null;

  customElements.define('occhio-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.link = this.closest('a');
      this.primary = this.querySelector('img.occhio-card-media__primary');
      this.image = this.querySelector('img.occhio-card-media__secondary');
      this.template = this.querySelector('template[data-occhio-secondary]');
      if (!this.image && !this.template) return;
      this.onIntent = () => this.loadSecondary();
      this.onPrimaryLoad = () => this.prepareSecondary();
      this.primary?.addEventListener('load', this.onPrimaryLoad, {once:true});
      this.link?.addEventListener('pointerenter', this.onIntent, {passive:true});
      this.link?.addEventListener('focusin', this.onIntent);
      this.link?.addEventListener('pointerdown', this.onIntent, {passive:true});
      observer?.observe(this);
      if (this.image) this.loadSecondary('low');
    }
    prepareSecondary() {
      if (!this.nearby || this.secondaryTask || !this.primary?.complete) return;
      pending.add(this);
      drain();
    }
    loadSecondary(priority = 'high') {
      pending.delete(this);
      observer?.unobserve(this);
      this.image ||= this.querySelector('img.occhio-card-media__secondary');
      let content;
      if (!this.image && this.template) {
        content = this.template.content.cloneNode(true);
        this.image = content.querySelector('img.occhio-card-media__secondary');
      }
      const image = this.image;
      if (!image) return Promise.resolve();
      const displayWidth = this.getBoundingClientRect().width;
      if (displayWidth > 0) image.sizes = Math.ceil(displayWidth) + 'px';
      if (priority === 'high' || !this.secondaryTask) image.fetchPriority = priority;
      image.loading = 'eager';
      if (this.secondaryTask) return this.secondaryTask;
      this.secondaryTask = new Promise(resolve => {
        let finished = false;
        let decoding = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          image.removeEventListener('load', ready);
          image.removeEventListener('error', failed);
          resolve();
        };
        const ready = () => {
          if (decoding || finished) return;
          decoding = true;
          const decoded = image.decode ? image.decode() : Promise.resolve();
          decoded.catch(() => {}).then(() => {
            if (finished) return;
            if (image.complete && image.naturalWidth > 0) image.classList.add('is-loaded');
            finish();
          });
        };
        const failed = () => { image.classList.remove('is-loaded'); finish(); };
        this.cancelSecondary = finish;
        image.addEventListener('load', ready);
        image.addEventListener('error', failed);
        if (content) {
          this.template.replaceWith(content);
          this.template = null;
        }
        if (image.complete) {
          if (image.naturalWidth > 0) ready();
          else failed();
        }
      });
      return this.secondaryTask;
    }
    disconnectedCallback() {
      observer?.unobserve(this);
      pending.delete(this);
      this.primary?.removeEventListener('load', this.onPrimaryLoad);
      this.link?.removeEventListener('pointerenter', this.onIntent);
      this.link?.removeEventListener('focusin', this.onIntent);
      this.link?.removeEventListener('pointerdown', this.onIntent);
      this.cancelSecondary?.();
      this.secondaryTask = null;
      this.nearby = false;
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-catalog-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const brandHandles = new Set(JSON.parse(document.querySelector('[data-occhio-brand-catalogs]')?.textContent || '[]'));
  const normalizeLink = (link) => {
    if (!(link instanceof HTMLAnchorElement) || !link.getAttribute('href')) return;
    let destination;
    try { destination = new URL(link.href, window.location.href); } catch { return; }
    if (destination.origin !== window.location.origin || !/\/collections\/[^/]+\/?$/.test(destination.pathname)) return;
    if (destination.searchParams.has('view')) return;
    const handle = decodeURIComponent(destination.pathname.replace(/\/$/, '').split('/').pop());
    if (brandHandles.has(handle)) destination.searchParams.delete('filter.v.availability');
    else if (!destination.searchParams.has('filter.v.availability')) destination.searchParams.set('filter.v.availability', '1');
    link.href = destination.pathname + destination.search + destination.hash;
  };
  const prepareLinks = () => document.querySelectorAll('a[href*="/collections/"]').forEach(normalizeLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareLinks, {once: true});
  else prepareLinks();
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element) normalizeLink(event.target.closest('a'));
  }, true);

  if (customElements.get('occhio-available-catalog')) return;
  customElements.define('occhio-available-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.loadAvailable();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.cleanup?.();
    }
    async loadAvailable() {
      const initial = new URL(window.location.href);
      const showAll = this.dataset.mode === 'all';
      if (showAll ? !initial.searchParams.has('filter.v.availability') : initial.searchParams.has('filter.v.availability')) return;
      const fallback = this.querySelector('[data-occhio-available-fallback]');
      const next = new URL(initial.href);
      if (showAll) next.searchParams.delete('filter.v.availability');
      else next.searchParams.set('filter.v.availability', '1');
      if (fallback) fallback.href = next.pathname + next.search + next.hash;
      const controller = new AbortController();
      this.controller = controller;
      const cancelForInput = (event) => {
        if (event.target instanceof Element && event.target.closest('facet-filters-form, facet-remove, #occhio-catalog select')) controller.abort();
      };
      const cancelForNavigation = () => controller.abort();
      document.addEventListener('input', cancelForInput, true);
      document.addEventListener('click', cancelForInput, true);
      window.addEventListener('popstate', cancelForNavigation);
      this.cleanup = () => {
        document.removeEventListener('input', cancelForInput, true);
        document.removeEventListener('click', cancelForInput, true);
        window.removeEventListener('popstate', cancelForNavigation);
      };
      try {
        await Promise.race([
          customElements.whenDefined('facet-filters-form'),
          new Promise((_, reject) => { this.timer = setTimeout(() => reject(new Error('Filters unavailable')), 8000); })
        ]);
        clearTimeout(this.timer);
        if (controller.signal.aborted || !this.isConnected) return;
        const grid = document.getElementById('product-grid');
        const facets = customElements.get('facet-filters-form');
        if (!grid?.dataset.id || !facets?.renderFilters) throw new Error('Catalog unavailable');
        const request = new URL(next.href);
        request.hash = '';
        request.searchParams.set('section_id', grid.dataset.id);
        this.timer = setTimeout(() => controller.abort('timeout'), 12000);
        const response = await fetch(request.pathname + request.search, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Catalog request failed');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.getElementById('ProductGridContainer')) throw new Error('Catalog incomplete');
        if (controller.signal.aborted || window.location.href !== initial.href || !this.isConnected) return;
        facets.renderFilters(html);
        facets.renderProductGridContainer(html, true);
        facets.renderProductCount(html);
        const parameters = next.searchParams.toString();
        facets.searchParamsInitial = parameters;
        facets.searchParamsPrev = parameters;
        history.replaceState({...history.state, searchParams: parameters}, '', next.pathname + next.search + next.hash);
        prepareLinks();
        this.dataset.status = 'ready';
      } catch (error) {
        if ((!controller.signal.aborted || controller.signal.reason === 'timeout') && fallback) fallback.hidden = false;
      } finally {
        clearTimeout(this.timer);
        this.cleanup();
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-cro11-behaviour"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('occhio-search-recovery')) {
  customElements.define('occhio-search-recovery', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.recover();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.started = false;
    }
    static queries(value) {
      const stop = new Set(['occhiali','occhiale','da','di','con','per','the','and','for','frame','frames','glasses','eyewear']);
      const words = (String(value).slice(0,160).toLowerCase().match(/[\p{L}\p{N}]+/gu) || []).filter(word => !stop.has(word));
      return [...new Set([words.join(' '), words.slice(0,2).join(' '), words[0] || ''])].filter(query => query.length >= 3).slice(0,3);
    }
    async recover() {
      const original = this.dataset.query || '';
      const sunOnly = /(?:^|\s)(sole|sunglasses)(?:\s|$)/i.test(original);
      const opticalOnly = /(?:^|\s)(vista|optical)(?:\s|$)/i.test(original);
      for (const query of this.constructor.queries(original)) {
        if (!this.isConnected) return;
        try {
          const root = (this.dataset.root || '/').replace(/\/?$/, '/');
          const url = new URL(root + 'search/suggest.json', location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '10');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          const response = await fetch(url, {signal:this.controller.signal, credentials:'same-origin'});
          if (!response.ok) return;
          const result = await response.json();
          const products = (result.resources?.results?.products || []).filter(product => {
            if (product.available !== true || !product.image) return false;
            const type = String(product.type || '').toLowerCase();
            return (!sunOnly || /sole|sunglass/.test(type)) && (!opticalOnly || /vista|optical/.test(type));
          }).slice(0,4);
          if (products.length && this.isConnected) {
            const cards = products.map(product => this.card(product)).filter(Boolean);
            if (!cards.length) continue;
            this.querySelector('[data-recovery-grid]').replaceChildren(...cards);
            this.querySelector('[data-recovery-title]').textContent = this.dataset.relatedTitle;
            this.querySelector('[data-recovery-intro]').textContent = this.dataset.relatedIntro;
            return;
          }
        } catch (error) {
          return;
        }
      }
    }
    card(product) {
      const url = new URL(product.url, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) return null;
      const variant = (product.variants || []).find(item => item.available);
      const price = Number(variant?.price ?? product.price);
      if (!Number.isFinite(price) || price < 0) return null;
      url.search = '';
      if (variant?.id) url.searchParams.set('variant', variant.id);
      const imageURL = new URL(product.image, location.origin);
      if (imageURL.protocol !== 'https:' || !(imageURL.hostname === location.hostname || imageURL.hostname.endsWith('.shopify.com'))) return null;
      imageURL.searchParams.set('width', '480');
      const card = document.createElement('a');
      card.className = 'occhio-search-recovery__card';
      card.href = url.pathname + url.search;
      card.dataset.occhioEvent = 'search_suggestion';
      const photo = document.createElement('img');
      photo.src = imageURL.href;
      photo.alt = product.title;
      photo.loading = 'lazy';
      photo.width = 480;
      photo.height = 360;
      const title = document.createElement('span');
      title.className = 'occhio-search-recovery__name';
      title.textContent = product.title;
      const amount = document.createElement('span');
      amount.className = 'occhio-search-recovery__price';
      amount.textContent = new Intl.NumberFormat(this.dataset.locale || 'it', {style:'currency', currency:this.dataset.currency || 'EUR'}).format(price);
      const stock = document.createElement('small');
      stock.textContent = this.dataset.availableLabel;
      card.append(photo, title, amount, stock);
      return card;
    }
  });
}

if (!customElements.get('occhio-delivery-date')) {
  customElements.define('occhio-delivery-date', class extends HTMLElement {
    static italianHoliday(date) {
      const year = date.getUTCFullYear();
      const fixed = ['01-01','01-06','04-25','05-01','06-02','08-15','11-01','12-08','12-25','12-26'];
      if (fixed.includes(date.toISOString().slice(5,10))) return true;
      const a=year%19, b=Math.floor(year/100), c=year%100, d=Math.floor(b/4), e=b%4;
      const f=Math.floor((b+8)/25), g=Math.floor((b-f+1)/3), h=(19*a+b-d-g+15)%30;
      const i=Math.floor(c/4), k=c%4, l=(32+2*e+2*i-h-k)%7, m=Math.floor((a+11*h+22*l)/451);
      const month=Math.floor((h+l-7*m+114)/31), day=(h+l-7*m+114)%31+1;
      const monday = new Date(Date.UTC(year,month-1,day+1,12));
      return date.toISOString().slice(0,10) === monday.toISOString().slice(0,10);
    }
    static deadline(now, days) {
      const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
      const part = name => Number(parts.find(item => item.type === name).value);
      const result = new Date(Date.UTC(part('year'),part('month')-1,part('day'),12));
      for (let added=0; added<days;) {
        result.setUTCDate(result.getUTCDate()+1);
        if ([0,6].includes(result.getUTCDay()) || this.italianHoliday(result)) continue;
        added++;
      }
      return result;
    }
    connectedCallback() {
      const days = Number(this.dataset.deliveryDays);
      if (![3,5].includes(days)) return;
      const target = this.querySelector('[data-delivery-output]');
      if (!target) return;
      const date = this.constructor.deadline(new Date(), days);
      const formatted = new Intl.DateTimeFormat(this.dataset.locale || 'it',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(date);
      target.textContent = (this.dataset.dateText || '').replace('__DATE__', formatted);
      target.setAttribute('datetime', date.toISOString().slice(0,10));
      target.hidden = false;
      const note = this.querySelector('[data-delivery-note]');
      if (note) note.hidden = false;
    }
  });
}

if (!customElements.get('occhio-cro-measurement')) {
  customElements.define('occhio-cro-measurement', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.onClick = event => {
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target) return;
        const link = target.closest('a[href]');
        if (link) {
          const url = new URL(link.href, location.origin);
          if (url.origin === location.origin) {
            if (url.pathname.endsWith('/collections/all') && url.searchParams.get('view') === 'scelta') {
              const placement = link.closest('[data-compare-bar]') ? 'compare_bar' : link.closest('dialog') ? 'compare_dialog' : location.pathname.includes('/products/') ? 'product' : location.pathname.includes('/collections/') ? 'collection' : location.pathname === '/' || /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(location.pathname) ? 'home' : 'other';
              this.record('finder_entry_click',{placement});
            }
            const source = link.dataset.occhioToolSource;
            const handle = url.pathname.match(/\/products\/([a-z0-9-]+)\/?$/)?.[1];
            if (['finder','compare'].includes(source) && handle) this.record(source+'_product_click',{product_handle:handle});
          }
        }
        const guide = target.closest('#ProductPopup-popup_bTaLFL');
        const tagged = target.closest('[data-occhio-event]');
        const whatsapp = target.closest('a[href^="https://wa.me/"],a[href^="https://api.whatsapp.com/"]');
        const alternative = target.closest('.occhio-sold-out-alternatives a, .related-products a[href*="/products/"]');
        const kind = guide ? 'size_guide' : tagged?.dataset.occhioEvent || (whatsapp ? 'whatsapp' : alternative ? 'alternative' : '');
        if (['size_guide','whatsapp','alternative','search_suggestion'].includes(kind)) {
          const details = {};
          const selectedLink = alternative || tagged;
          if (selectedLink?.matches('a[href]')) {
            const selectedURL = new URL(selectedLink.href, location.origin);
            if (selectedURL.origin === location.origin) details.product_handle = selectedURL.pathname.match(/\/products\/([a-z0-9-]+)\/?$/)?.[1];
          }
          this.record(kind, details);
        }
      };
      this.onToggle = event => {
        const panel = event.target;
        if (!(panel instanceof Element) || !panel.open) return;
        if (panel.matches('occhio-product-video details')) this.record('video_open');
        if (panel.matches('[data-occhio-fit-panel]')) this.record('size_guide', {product_handle:panel.dataset.productHandle});
      };
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('toggle', this.onToggle, true);
      this.onConsent = () => {
        if (!this.canMeasure()) { this.clearAssist(); return; }
        if (document.querySelector('occhio-frame-finder')) this.record('finder_open');
      };
      document.addEventListener('visitorConsentCollected',this.onConsent);
      this.onReady = () => this.bindCartEvents();
      this.bindCartEvents();
      document.addEventListener('DOMContentLoaded',this.onReady,{once:true});
      window.addEventListener('load',this.onReady,{once:true});
      if (this.dataset.live === 'true' && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
      }
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onClick, true);
      document.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('visitorConsentCollected',this.onConsent);
      document.removeEventListener('DOMContentLoaded',this.onReady);
      window.removeEventListener('load',this.onReady);
      this.cartUnsubscribe?.();
      this.cartUnsubscribe = null;
      this.bound = false;
    }
    canMeasure() {
      try { return this.dataset.live !== 'true' || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
      catch (_) { return false; }
    }
    assistKey() {
      return ['occhio-cro-assist-v1',this.dataset.live === 'true' ? 'live' : 'preview',this.dataset.country,this.dataset.currency].join(':');
    }
    clearAssist() {
      this.assist = Object.create(null);
      try { sessionStorage.removeItem(this.assistKey()); } catch (_) {}
    }
    readAssist() {
      if (!this.canMeasure()) return Object.create(null);
      const cleaned = Object.create(null), now = Date.now();
      let saved = this.assist;
      if (!saved) { try { saved = JSON.parse(sessionStorage.getItem(this.assistKey()) || '{}'); } catch (_) { saved = {}; } }
      for (const [handle,sources] of Object.entries(saved || {}).slice(-30)) {
        if (!/^[a-z0-9-]{1,160}$/.test(handle) || !sources || typeof sources !== 'object') continue;
        for (const source of ['finder','compare']) {
          const time = sources[source];
          if (Number.isFinite(time) && time <= now && now - time < 1800000) {
            cleaned[handle] ||= {};
            cleaned[handle][source] = time;
          }
        }
      }
      this.assist = cleaned;
      return cleaned;
    }
    rememberAssist(handle,source) {
      const saved = this.readAssist();
      saved[handle] ||= {};
      saved[handle][source] = Date.now();
      const handles = Object.keys(saved);
      if (handles.length > 30) delete saved[handles[0]];
      try { sessionStorage.setItem(this.assistKey(),JSON.stringify(saved)); } catch (_) {}
    }
    bindCartEvents() {
      if (this.cartUnsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
      this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate,event => {
        if (event?.source !== 'product-form' || event.cartData?.status || !this.canMeasure()) return;
        const lines = event.cartData?.items || [event.cartData];
        const handles = new Set(lines.map(line => line?.handle).filter(handle => typeof handle === 'string' && /^[a-z0-9-]{1,160}$/.test(handle)));
        const saved = this.readAssist();
        for (const handle of handles) for (const source of ['finder','compare']) if (saved[handle]?.[source]) this.record(source+'_add_to_cart',{product_handle:handle,cart_method:'product'});
      });
    }
    record(kind,details = {}) {
      const allowed = ['size_guide','whatsapp','alternative','search_suggestion','video_open','finder_entry_click','finder_open','finder_start','finder_submit','finder_complete','finder_no_results','finder_error','finder_product_click','compare_add','compare_remove','compare_open','compare_product_click','finder_add_to_cart','compare_add_to_cart','finder_step','finder_restore','finder_more_results','selection_save','selection_copy','selection_restore','compare_difference_toggle'];
      if (!allowed.includes(kind) || !this.canMeasure()) return false;
      if (kind === 'finder_open' && this.finderOpened || kind === 'finder_start' && this.finderStarted) return false;
      const params = {};
      if (details && typeof details === 'object') {
        if (typeof details.product_handle === 'string' && /^[a-z0-9-]{1,160}$/.test(details.product_handle)) params.product_handle = details.product_handle;
        for (const key of ['result_count','selection_count']) if (Number.isInteger(details[key]) && details[key] >= 0 && details[key] <= 3) params[key] = details[key];
        if (['sun','optical'].includes(details.frame_kind)) params.frame_kind = details.frame_kind;
        if (['home','collection','product','compare_bar','compare_dialog','other'].includes(details.placement)) params.placement = details.placement;
        if (['load','results'].includes(details.stage)) params.stage = details.stage;
        if (Number.isInteger(details.step_number) && details.step_number >= 1 && details.step_number <= 4) params.step_number = details.step_number;
        if (['type','style','budget','size'].includes(details.step_name)) params.step_name = details.step_name;
        if (typeof details.differences_only === 'boolean') params.differences_only = details.differences_only;
        if (['comparison','product'].includes(details.cart_method)) params.cart_method = details.cart_method;
      }
      if (params.product_handle && ['finder_product_click','compare_product_click'].includes(kind)) this.rememberAssist(params.product_handle,kind.split('_')[0]);
      const eventName = 'occhio_' + kind;
      if (this.dataset.live !== 'true') {
        this.dispatchEvent(new CustomEvent('occhio:preview-interaction',{detail:{event:eventName,...params},bubbles:true}));
        if (new URLSearchParams(location.search).get('occhio_qa') === '1') {
          this.qaEvents ||= [];
          this.qaEvents.push({event:eventName,...params});
          this.qaEvents = this.qaEvents.slice(-80);
          this.dataset.occhioQa = 'local-only';
          const navigation = performance.getEntriesByType('navigation')[0];
          const paint = performance.getEntriesByName('first-contentful-paint')[0];
          this.textContent = JSON.stringify({events:this.qaEvents,timing:{domContentLoadedMs:Math.round(navigation?.domContentLoadedEventEnd || 0),loadMs:Math.round(navigation?.loadEventEnd || 0),firstContentfulPaintMs:Math.round(paint?.startTime || 0)}});
        }
      } else {
        if (typeof window.gtag !== 'function') return false;
        try {
          window.gtag('event', eventName, {
            send_to:this.dataset.measurementId,
            event_category:'occhio_cro',
            event_label:location.pathname,
            shopify_country:this.dataset.country,
            shopify_currency:this.dataset.currency,
            storefront_language:this.dataset.language,
            page_location:location.origin + location.pathname,
            ...params
          });
        } catch (_) { return false; }
      }
      if (kind === 'finder_open') this.finderOpened = true;
      if (kind === 'finder_start') this.finderStarted = true;
      return true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-hover-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('occhio-hover-menu')) {
  customElements.define('occhio-hover-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.item) return;
      const template = this.querySelector('template');
      const item = this.closest('.list-menu__has-mega');
      if (!template || !item) return;
      this.item = item;
      this.prepare = () => {
        if (this.ready || !this.isConnected) return;
        this.ready = true;
        this.replaceChildren(template.content.cloneNode(true));
        this.removeListeners();
      };
      item.addEventListener('pointerenter', this.prepare);
      item.addEventListener('focusin', this.prepare);
      if (item.matches(':hover') || item.contains(document.activeElement)) this.prepare();
    }
    removeListeners() {
      this.item?.removeEventListener('pointerenter', this.prepare);
      this.item?.removeEventListener('focusin', this.prepare);
      this.item = null;
    }
    disconnectedCallback() {
      this.removeListeners();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-navigation-prefetch"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const config = document.querySelector('[data-occhio-navigation-prefetch]');
    if (!config || window.Shopify?.designMode) return;

    const connection = navigator.connection;
    const canPrefetch = () => document.visibilityState !== 'hidden' &&
      !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '');
    if (!canPrefetch()) return;

    const supportsRules = window.HTMLScriptElement?.supports?.('speculationrules');
    const probe = document.createElement('link');
    if (!supportsRules && !probe.relList?.supports?.('prefetch')) return;

    const home = new URL(JSON.parse(config.textContent).home, location.origin);
    const root = home.pathname.replace(/\/?$/, '/');
    const current = new URL(location.href);
    current.hash = '';
    const warmed = new Set();
    const maximum = 4;

    const eligible = (href) => {
      let url;
      try { url = new URL(href, location.href); } catch { return null; }
      url.hash = '';
      if (url.origin !== location.origin || url.href === current.href || url.search) return null;
      if (url.pathname.replace(/\/$/, '') === home.pathname.replace(/\/$/, '')) return url;
      if (!url.pathname.startsWith(root)) return null;
      const path = url.pathname.slice(root.length);
      return /^(collections|products|pages|blogs)\/[^/]+/.test(path) ? url : null;
    };

    const prefetch = (href) => {
      if (!canPrefetch() || warmed.size >= maximum) return;
      const url = eligible(href);
      if (!url || warmed.has(url.href)) return;
      warmed.add(url.href);
      if (supportsRules) {
        const rule = document.createElement('script');
        rule.type = 'speculationrules';
        rule.dataset.occhioPrefetch = '';
        rule.textContent = JSON.stringify({ prefetch: [{ urls: [url.href] }] });
        document.head.appendChild(rule);
      } else {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = url.href;
        link.setAttribute('fetchpriority', 'low');
        document.head.appendChild(link);
      }
    };

    const linkFrom = (target) => {
      const link = target?.closest?.('a[href]');
      if (!link || link.hasAttribute('download') ||
          (link.target && link.target !== '_self') ||
          link.getAttribute('href').startsWith('#') ||
          link.hasAttribute('data-no-instant') ||
          link.relList.contains('nofollow')) return null;
      return link;
    };

    let timer;
    let hovered;
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const link = linkFrom(event.target);
      if (!link || link === hovered) return;
      clearTimeout(timer);
      hovered = link;
      timer = setTimeout(() => prefetch(link.href), 75);
    }, { passive: true });
    document.addEventListener('pointerout', (event) => {
      if (hovered && !hovered.contains(event.relatedTarget)) {
        clearTimeout(timer);
        hovered = null;
      }
    }, { passive: true });
    for (const type of ['focusin', 'pointerdown']) {
      document.addEventListener(type, (event) => {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        const link = linkFrom(event.target);
        if (link) prefetch(link.href);
      }, { passive: true });
    }

    if (location.pathname.replace(/\/$/, '') !== home.pathname.replace(/\/$/, '')) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => prefetch(home.href), { timeout: 1500 });
      } else {
        setTimeout(() => prefetch(home.href), 1200);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-product-focus"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const quizLink = event.target.closest('.occhio-product-focus a[data-quiz-entry-link]');
  if (quizLink) {
    const payload = { event: 'quiz_entry_click', placement: quizLink.getAttribute('data-quiz-entry-placement') || 'product', locale: document.documentElement.lang || '' };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (_) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('quiz_entry_click', payload); } catch (_) {}
    try { if (typeof window.track === 'function') window.track('quiz_entry_click', payload); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('occhio:quiz_entry_click', { detail: payload })); } catch (_) {}
  }
  const link = event.target.closest('a[data-occhio-fit-link]');
  if (!link) return;
  const panel = document.getElementById(link.hash.slice(1));
  if (panel instanceof HTMLDetailsElement) panel.open = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-purchase-confidence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('occhio-purchase-confidence')) {
  customElements.define('occhio-purchase-confidence', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.productInfo = this.closest('product-info');
      this.onVariantInput = (event) => {
        if (event.target instanceof Element && event.target.closest('variant-selects')) this.hidden = true;
      };
      this.productInfo?.addEventListener('change', this.onVariantInput, true);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event.data.sectionId) !== this.dataset.sectionId) return;
        const updated = event.data.html.getElementById(this.id);
        if (!updated) return;
        this.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
        this.hidden = false;
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = undefined;
      this.productInfo?.removeEventListener('change', this.onVariantInput, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-quiz-email-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('occhio-quiz-email-preview')) {
  class OcchioQuizEmailPreview extends HTMLElement {
    static KLAVIYO = 'https://a.klaviyo.com/client/%s/?company_id=SuXv5f';
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.finder = this.closest('occhio-frame-finder');
      this.form = this.querySelector('[data-quiz-email-form]');
      this.status = this.querySelector('[data-quiz-email-status]');
      this.strings = JSON.parse(this.querySelector('[data-quiz-email-strings]').textContent);
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.finder.querySelector('[data-finder-cards]'), {childList:true});
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity() || !this.finder.currentProducts?.length) return;
        this.send(this.form.elements.email.value, this.form.elements.newsletter.checked, {button: this.form.querySelector('[type=submit]'), status: this.status});
      });
      this.requestButton = this.querySelector('[data-quiz-request]');
      this.requestButton?.addEventListener('click', () => this.requestSend());
      this.refresh();
      this.identified().then(identified => {
        this.finder.querySelectorAll('[data-quiz-email-promo]').forEach(node => { node.hidden = identified; });
        this.finder.querySelectorAll('[data-quiz-consent-label]').forEach(node => {
          const text = identified ? node.dataset.labelPlain : node.dataset.labelPromo;
          if (text) node.textContent = text;
        });
      });
    }
    klaviyoCookie() {
      try {
        const raw = document.cookie.split('; ').find(part => part.startsWith('__kla_id='));
        if (!raw) return null;
        const data = JSON.parse(atob(decodeURIComponent(raw.slice(9))));
        return data && typeof data === 'object' ? data : null;
      } catch (_) { return null; }
    }
    async identified() {
      const cookie = this.klaviyoCookie();
      if (cookie && (cookie.$email || cookie.$exchange_id)) return true;
      try {
        if (window.klaviyo && typeof klaviyo.isIdentified === 'function') return Boolean(await klaviyo.isIdentified());
      } catch (_) {}
      return false;
    }
    async trackStart() {
      const key = 'occhio-quiz-started';
      try { if (sessionStorage.getItem(key)) return; } catch (_) {}
      const locale = String(this.dataset.locale || '').toLowerCase().split('-')[0];
      const properties = {kind: this.answers().kind, locale, page_url: location.href};
      const cookie = this.klaviyoCookie() || {};
      const profile = cookie.$email ? {email: cookie.$email} : cookie.$exchange_id ? {_kx: cookie.$exchange_id} : null;
      try {
        if (profile) {
          await this.post('events', {type: 'event', attributes: {metric: {data: {type: 'metric', attributes: {name: 'Quiz iniziato'}}}, profile: {data: {type: 'profile', attributes: profile}}, properties}});
        } else if (await this.identified() && window.klaviyo && typeof klaviyo.push === 'function') {
          klaviyo.push(['track', 'Quiz iniziato', properties]);
        } else return;
        sessionStorage.setItem(key, '1');
      } catch (_) {}
    }
    answers() {
      const form = this.finder.querySelector('[data-finder-form]');
      const data = {...(form ? Object.fromEntries(new FormData(form)) : {}), ...(this.finder.resultPreferences || {})};
      const text = key => String(data[key] ?? '').trim().slice(0, 120);
      const num = key => { const n = Number(text(key)); return text(key) && Number.isFinite(n) && n > 0 ? n : null; };
      return {kind: text('kind') === 'optical' ? 'optical' : 'sun', gender: ['donna', 'uomo'].includes(text('gender')) ? text('gender') : 'unisex', origin: ['jp', 'fr', 'it', 'pt', 'north'].includes(text('origin')) ? text('origin') : 'any', shape: text('shape'), material: text('material'), budget: num('budget'), lens: num('lens'), bridge: num('bridge'), temple: num('temple')};
    }
    products() {
      const absolute = (value, width) => {
        try {
          const url = new URL(value, location.origin);
          if (url.protocol !== 'https:') return '';
          if (width) url.searchParams.set('width', String(width));
          return url.href;
        } catch (_) { return ''; }
      };
      return this.finder.currentProducts.slice(0, 3).map(product => ({
        title: String(product.displayTitle || product.title || '').trim(),
        url: product.url ? absolute(product.url) : '',
        image: product.image ? absolute(product.image, 600) : '',
        price: String(product.priceFormatted || '').trim(),
        vendor: String(product.brand || product.vendor || '').trim()
      }));
    }
    post(kind, data) {
      const options = {method:'POST', headers:{'Content-Type':'application/json', revision:'2024-10-15'}, body:JSON.stringify({data})};
      if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) options.signal = AbortSignal.timeout(15000);
      return fetch(OcchioQuizEmailPreview.KLAVIYO.replace('%s', kind), options).then(response => {
        if (!response.ok) throw new Error('Klaviyo ' + kind + ' ' + response.status);
      });
    }
    static SENT_KEY = 'occhio-quiz-sent';
    static SENT_DAYS = 30;
    alreadySent() {
      try {
        const raw = localStorage.getItem(OcchioQuizEmailPreview.SENT_KEY);
        const at = raw ? Date.parse(raw) : NaN;
        return Number.isFinite(at) && Date.now() - at < OcchioQuizEmailPreview.SENT_DAYS * 864e5;
      } catch (_) { return false; }
    }
    markSent() {
      try { localStorage.setItem(OcchioQuizEmailPreview.SENT_KEY, new Date().toISOString()); } catch (_) {}
    }
    buildProps(newsletter, requested = false) {
      const answers = this.answers();
      const products = this.products();
      const locale = String(this.dataset.locale || '').toLowerCase().split('-')[0];
      const lang = ['it', 'en'].includes(locale) ? locale : '';
      const sizes = [answers.lens, answers.bridge, answers.temple];
      const profileProperties = {'Quiz tipo': answers.kind, 'Quiz per chi': answers.gender, 'Quiz origine': answers.origin};
      if (answers.shape) profileProperties['Quiz forma'] = answers.shape;
      if (answers.material) profileProperties['Quiz materiale'] = answers.material;
      if (answers.budget) profileProperties['Quiz budget'] = answers.budget;
      if (sizes.some(Boolean)) profileProperties['Quiz misure'] = sizes.map(value => value ?? '').join('-');
      if (lang) profileProperties['[RO] Lang'] = lang;
      const properties = {...answers, locale: lang || locale, results_url: location.href, products, newsletter: Boolean(newsletter), requested: Boolean(requested)};
      return {answers, products, profileProperties, properties};
    }
    maskEmail(value) {
      const email = String(value || '').trim();
      const at = email.lastIndexOf('@');
      if (at < 1) return '';
      return email.charAt(0) + '…' + email.slice(at);
    }
    showReceipt(products, newsletter, email) {
      const list = this.querySelector('[data-quiz-email-models]');
      list.replaceChildren();
      products.forEach(product => {
        const item = document.createElement('li');
        item.textContent = product.title;
        list.append(item);
      });
      const masked = this.maskEmail(email);
      this.querySelector('[data-quiz-email-sent]').textContent = masked ? String(this.strings.sent_to || '').replace('{email}', masked) : this.strings.sent_generic || this.strings.done;
      this.querySelector('[data-quiz-email-receipt]').hidden = false;
      this.classList.add('is-sent');
      this.classList.remove('is-request');
      this.querySelector('[data-quiz-email-request]').hidden = true;
      this.status.textContent = '';
      this.sentFor = this.finder.revision;
    }
    async autoSend() {
      try {
        if (this.pending || !this.finder.currentProducts?.length) return false;
        if (!window.klaviyo || typeof klaviyo.push !== 'function') return false;
        if (!await this.identified()) return false;
        const {products, profileProperties, properties} = this.buildProps(false, false);
        const signature = this.signature(products, properties);
        let already = false;
        try { already = sessionStorage.getItem(OcchioQuizEmailPreview.SESSION_KEY) === signature; } catch (_) {}
        if (!already && this.alreadySent()) {
          this.showRequest();
          return false;
        }
        if (!already) {
          klaviyo.push(['track', 'Quiz completato', properties]);
          if (properties.origin) klaviyo.push(['identify', profileProperties]);
          try { sessionStorage.setItem(OcchioQuizEmailPreview.SESSION_KEY, signature); } catch (_) {}
          this.markSent();
        }
        this.autoSent = true;
        this.showReceipt(products, false, (this.klaviyoCookie() || {}).$email);
        return true;
      } catch (_) { return false; }
    }
    static SESSION_KEY = 'occhio-quiz-autosent';
    signature(products, properties) {
      return products.map(product => product.url || product.title).concat(properties.origin, properties.kind, properties.gender).join('|');
    }
    showRequest() {
      const row = this.querySelector('[data-quiz-email-request]');
      if (!row) return;
      this.querySelector('[data-quiz-request-status]').textContent = '';
      if (this.requestButton) this.requestButton.disabled = false;
      row.hidden = false;
      this.classList.add('is-request');
      this.status.textContent = '';
      this.requestFor = this.finder.revision;
    }
    async requestSend() {
      const status = this.querySelector('[data-quiz-request-status]');
      const button = this.requestButton;
      if (this.pending || !button || button.disabled || !this.finder.currentProducts?.length) return false;
      const cookieEmail = String((this.klaviyoCookie() || {}).$email || '').trim();
      const viaKlaviyoJs = Boolean(window.klaviyo && typeof klaviyo.push === 'function');
      if (!viaKlaviyoJs) {
        if (!cookieEmail) { status.textContent = this.strings.error; return false; }
        const sent = await this.send(cookieEmail, false, {button, status}, true);
        if (sent) button.disabled = true;
        return sent;
      }
      const {products, profileProperties, properties} = this.buildProps(false, true);
      this.pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = this.strings.sending;
      try {
        if (cookieEmail) klaviyo.push(['identify', Object.assign({'$email': cookieEmail}, profileProperties)]);
        else if (properties.origin) klaviyo.push(['identify', profileProperties]);
        klaviyo.push(['track', 'Quiz completato', properties]);
        try { sessionStorage.setItem(OcchioQuizEmailPreview.SESSION_KEY, this.signature(products, properties)); } catch (_) {}
        this.markSent();
      } catch (_) {
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        status.textContent = this.strings.error;
        return false;
      }
      this.pending = false;
      button.removeAttribute('aria-busy');
      status.textContent = this.strings.request_done || this.strings.sent_generic;
      this.sentFor = this.finder.revision;
      return true;
    }
    async send(emailValue, newsletterChecked, ui, requestedFlag) {
      const email = String(emailValue || '').trim();
      const newsletter = Boolean(newsletterChecked);
      const button = ui?.button || this.form.querySelector('[type=submit]');
      const status = ui?.status || this.status;
      if (this.pending || !email || !this.finder.currentProducts?.length) return false;
      const requested = typeof requestedFlag === 'boolean' ? requestedFlag : this.alreadySent();
      const {products, profileProperties, properties} = this.buildProps(newsletter, requested);
      const viaKlaviyoJs = Boolean(window.klaviyo && typeof klaviyo.push === 'function');
      const requests = viaKlaviyoJs ? [] : [this.post('events', {
        type: 'event',
        attributes: {
          metric: {data: {type: 'metric', attributes: {name: 'Quiz completato'}}},
          profile: {data: {type: 'profile', attributes: {email, properties: profileProperties}}},
          properties
        }
      })];
      if (newsletter) requests.push(this.post('subscriptions', {
        type: 'subscription',
        attributes: {
          custom_source: 'Quiz OCCHIO',
          profile: {data: {type: 'profile', attributes: {email, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}}}}
        },
        relationships: {list: {data: {type: 'list', id: 'XrbZLu'}}}
      }));
      this.pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = this.strings.sending;
      let sent = false;
      try {
        if (viaKlaviyoJs) {
          klaviyo.push(['identify', Object.assign({'$email': email}, profileProperties)]);
          klaviyo.push(['track', 'Quiz completato', properties]);
        }
        await Promise.all(requests);
        sent = true;
        try { sessionStorage.setItem(OcchioQuizEmailPreview.SESSION_KEY, this.signature(products, properties)); } catch (_) {}
        this.markSent();
      } catch (_) {
        sent = false;
      } finally {
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      if (!sent) {
        status.textContent = this.strings.error;
        return false;
      }
      if (status !== this.status) status.textContent = '';
      this.showReceipt(products, newsletter, email);
      return true;
    }
    refresh() {
      this.hidden = !this.finder.currentProducts?.length;
      if (this.pending || this.sentFor === this.finder.revision) return;
      this.querySelector('[data-quiz-email-receipt]').hidden = true;
      this.classList.remove('is-sent');
      if (this.requestFor !== this.finder.revision) {
        this.querySelector('[data-quiz-email-request]').hidden = true;
        this.classList.remove('is-request');
      }
      this.status.textContent = '';
    }
    disconnectedCallback() {this.observer?.disconnect();this.initialized = false;}
  }
  customElements.define('occhio-quiz-email-preview', OcchioQuizEmailPreview);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occhio-shipping-summary"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.occhioGeoShipping) return;
  var SEL = '.occhio-shipping-summary[data-occhio-geo]:not([data-geo-applied])';
  var detected = null;
  var pending = false;
  var failed = false;
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function countryName(code, fallback) {
    try {
      var name = new Intl.DisplayNames([document.documentElement.lang || 'it'], { type: 'region' }).of(code);
      if (name && name !== code) return name;
    } catch (e) {}
    return fallback || code;
  }
  function groupFor(code, el) {
    if (code === 'IT' || code === 'NO' || code === 'US' || code === 'GB') return code;
    if (code === 'AU' || code === 'NZ') return 'GB';
    if ((el.getAttribute('data-geo-eu') || '').split(',').indexOf(code) !== -1) return 'EU';
    if ((el.getAttribute('data-geo-intl') || '').split(',').indexOf(code) !== -1) return 'INTL';
    return 'OTHER';
  }
  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
      el.setAttribute('data-geo-applied', '');
      var current = el.getAttribute('data-shipping-country');
      if (!current || current === detected.code) return;
      var tpl = el.querySelector('template[data-occhio-geo-template="' + groupFor(detected.code, el) + '"]');
      if (!tpl) return;
      var templates = Array.prototype.slice.call(el.querySelectorAll('template[data-occhio-geo-template]'));
      el.innerHTML = tpl.innerHTML.split('__OCCHIO_COUNTRY__').join(esc(countryName(detected.code, detected.name)));
      templates.forEach(function (t) { el.appendChild(t); });
      el.setAttribute('data-shipping-country', detected.code);
      el.setAttribute('data-shipping-country-original', current);
    });
  }
  function use(c) {
    var code = c && c.handle ? String(c.handle).toUpperCase() : '';
    if (!/^[A-Z]{2}$/.test(code)) { failed = true; return; }
    detected = { code: code, name: c.name };
    apply();
  }
  function ensure() {
    if (failed || !document.querySelector(SEL)) return;
    if (detected) return apply();
    if (pending) return;
    pending = true;
    try {
      var cached = JSON.parse(sessionStorage.getItem('occhioDetectedCountry') || 'null');
      if (cached && cached.handle) return use(cached);
    } catch (e) {}
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        try { if (c && c.handle) sessionStorage.setItem('occhioDetectedCountry', JSON.stringify({ handle: c.handle, name: c.name })); } catch (e) {}
        use(c);
      })
      .catch(function () { failed = true; });
  }
  window.occhioGeoShipping = { apply: ensure };
  function start() {
    ensure();
    if (window.MutationObserver && document.body) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; ensure(); }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
